import { EMPTY_LIST } from '../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'
import {
  DOC_FLOW_FORM_FIELD_BUILDING_GROUPS,
  DOC_FLOW_FORM_FIELD_BUILDINGS,
  DOC_FLOW_FORM_FIELD_CONNECTED_REQUESTS,
  DOC_FLOW_FORM_FIELD_FILES,
  DOC_FLOW_FORM_FIELD_FINAL_DOCUMENT_TITLE,
  DOC_FLOW_FORM_FIELD_TITLE,
  DOC_FLOW_FORM_FIELD_VARIABLE,
} from '../DocFlow.constants'

export const DOC_FLOW_FORM_INITIAL_VALUES = {
  [DOC_FLOW_FORM_FIELD_BUILDING_GROUPS]: null,
  [DOC_FLOW_FORM_FIELD_BUILDINGS]: null,
  [DOC_FLOW_FORM_FIELD_CONNECTED_REQUESTS]: EMPTY_LIST,
  [DOC_FLOW_FORM_FIELD_FILES]: EMPTY_LIST,
  [DOC_FLOW_FORM_FIELD_FINAL_DOCUMENT_TITLE]: FORMIK_EMPTY_VALUE,
  [DOC_FLOW_FORM_FIELD_TITLE]: FORMIK_EMPTY_VALUE,
  [DOC_FLOW_FORM_FIELD_VARIABLE]: FORMIK_EMPTY_VALUE,
}
